export default __webpack_public_path__ + "static/media/photo8.0d5eda86.jpg";